'use strict';

var elementCtrl = ["graphDataFactory", "$scope", function (graphDataFactory, $scope) {
    var _this = this;
    // Solo aplicar el preset si todavía no hay un valor elegido, así al cambiar
    // de página y recrearse la directiva no se pisa la fecha seleccionada por el usuario.
    if (_this.element.preset && !_this.element.value){
        let date = new Date();
        date.setDate(date.getDate() + (_this.element.presetValue||0));
        _this.element.value = date;
    }
       
    $scope.updateValue = function () {
        _this.onChange(_this.element);
    };

    _this.hasDate = () => {
        const v = _this.element && _this.element.value;
        if (v === undefined || v === null || v === "") return false;
        if (v instanceof Date) return !isNaN(v.getTime());
        return true;
    };

    _this.clearDate = ($event) => {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        _this.element.value = undefined;
        $scope.status.openedDesde = false;
        _this.onChange(_this.element);
    };

    $scope.dateOptions = {
        formatYear: 'yyyy',
        startingDay: 1
    };

    $scope.status = {
        opened: false
    };
    $scope.openCalendario = function ($event, obj) {
        $scope.status[obj] = true;
    };

    $scope.formats = ['dd-MMMM-yyyy', 'yyyy-MM-dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[1];
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            onChange: '&'
        },
        replace: true,
        controller: elementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graph-view/graphDateViewDirective.html'
    };
};